import React from 'react';
import Select from 'react-select';
import Flexbox from 'flexbox-react';
import { Input, Popover } from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { css } from 'emotion';

import InfoBoxLabel from 'components/core/InfoBoxLabel';
import ProcessService from 'services/ProcessService';
import { popoverErrorStyle, colorRed } from 'styles/base.js';
import InfoMessages from 'components/core/help/InfoMessages';

class TemplateOptionsForm extends React.Component {

    static propTypes = {
        processId: PropTypes.string,
        process: PropTypes.object,
        projectParameters: PropTypes.object,
        projectParameterErrors: PropTypes.object
    };

    getTemplateOptions() {
        
        let options = [];

        if (this.props.process.type === 'VAP') {
            options = [
                { value: 'vap-py-transform', label: 'vap-py-transform' },
                { value: 'vap-py-retriever', label: 'vap-py-retriever' },
                { value: 'vap-c-transform', label: 'vap-c-transform' },
                { value: 'vap-c-retriever', label: 'vap-c-retriever' }
            ];
        } else {
            options = [
                { value: 'ingest-c-standard', label: 'ingest-c-standard' },
                { value: 'ingest-c-csv', label: 'ingest-c-csv' },
                { value: 'ingest-c-csv2', label: 'ingest-c-csv2' },
                { value: 'ingest-py', label: 'ingest-py' }
            ];
        }

        return options;
    }

    getInfoMessage() {
        if (this.props.process.type === 'VAP') {
            return InfoMessages.vapTemplateOptions;
        }
        return InfoMessages.ingestTemplateOptions;
    }
    
    onRadioButtonChange = event => {
        const parameters = _.cloneDeep(this.props.projectParameters);
        parameters.project_download = event.target.value;     
        ProcessService.updateCreateProjectParameters(this.props.process.name, parameters);
    };

    onInputFieldChange = fieldName => event => {
        const parameters = _.cloneDeep(this.props.projectParameters);
        parameters[fieldName] = event.target.value.trim();
        ProcessService.updateCreateProjectParameters(this.props.process.name, parameters);
    };

    onTemplateChange = value => {
        const parameters = _.cloneDeep(this.props.projectParameters);
        parameters.project_template = value;
        ProcessService.updateCreateProjectParameters(this.props.process.name, parameters);
    };

    renderForm() {
        const labelWidth = '100px';
        const marginBottom = '15px';

        const templateSelected = this.props.projectParameters.project_template !== '';
        const hasName = this.props.projectParameters.project_name !== '';

        let selectComponent = (
            <Select
                classNamePrefix="react-select"
                value={this.props.projectParameters.project_template}
                options={this.getTemplateOptions()}
                onChange={this.onTemplateChange}
                placeholder="Select template..."
                autoFocus
                isMulti={false}
            />
        );

        let selectErrorStyle = '';
        let inputErrorStyle = '';

        if (!templateSelected) {
            const errorMessage = 'A template must be selected in order to run create ADI project';
            selectComponent = (
                <Popover content={errorMessage} placement="top" overlayClassName={popoverErrorStyle}>
                    <div>{selectComponent}</div>
                </Popover>
            );

            selectErrorStyle = css`
                .react-select__control {
                    border-color: ${colorRed} !important;
                }
            `;
        }

        if (!hasName) {
            inputErrorStyle = css`
                .ant-input {
                    border-color: ${colorRed} !important;
                }
            `;
        }

        return (
            <div className="create-adi-project-form">
                <Flexbox flexDirection="row" alignItems="flex-start" marginBottom={marginBottom}>
                    {/* Project Name */}
                    <InfoBoxLabel 
                        label="Project Name"
                        width={labelWidth}
                        message={InfoMessages.projectName}
                        tooltipPosition="left"
                    />
                    <div className={inputErrorStyle} style={ { flexGrow: 1, marginLeft: '10px' } }>                    
                        <Input
                            value={this.props.projectParameters.project_name}
                            onChange={this.onInputFieldChange('project_name')}
                            placeholder="Name your project"
                            size="small"
                            allowClear
                        />
                    </div>
                </Flexbox>
                {/* Author Name */}
                <Flexbox flexDirection="row" alignItems="flex-start" marginBottom={marginBottom}>
                    <InfoBoxLabel 
                        label="Author Name"
                        width={labelWidth}
                        message={InfoMessages.authorName}
                        tooltipPosition="left"
                    />
                    <div style={ { flexGrow: 1, marginLeft: '10px' } }>                    
                        <Input
                            value={this.props.projectParameters.author_name}
                            onChange={this.onInputFieldChange('author_name')}
                            placeholder="Author name"
                            size="small"
                            allowClear
                        />
                    </div>
                </Flexbox>
                {/* Author Phone Number */}
                <Flexbox flexDirection="row" alignItems="flex-start" marginBottom={marginBottom}>
                    <InfoBoxLabel 
                        label="Phone Number"
                        width={labelWidth}
                        message={InfoMessages.phoneNumber}
                        tooltipPosition="left"
                    />
                    <div style={ { flexGrow: 1, marginLeft: '10px' } }>                    
                        <Input
                            value={this.props.projectParameters.phone_number}
                            onChange={this.onInputFieldChange('phone_number')}
                            placeholder="Phone number"
                            size="small"
                            allowClear
                        />
                    </div>
                </Flexbox>
                {/* Author Email */}
                <Flexbox flexDirection="row" alignItems="flex-start" marginBottom={marginBottom}>
                    <InfoBoxLabel 
                        label="Author Email"
                        width={labelWidth}
                        message={InfoMessages.emailAddress}
                        tooltipPosition="left"
                    />
                    <div style={ { flexGrow: 1, marginLeft: '10px' } }>                    
                        <Input
                            value={this.props.projectParameters.email_address}
                            onChange={this.onInputFieldChange('email_address')}
                            placeholder="Author email"
                            size="small"
                            allowClear
                        />
                    </div>
                </Flexbox>
                <Flexbox alignItems="center" flexDirection="row" marginBottom={marginBottom}>
                    <InfoBoxLabel
                        label="Template"
                        width={labelWidth}
                        message={this.getInfoMessage()}
                        tooltipPosition="left"
                    />
                    <div className={selectErrorStyle} style={ { flexGrow: 1, marginLeft: '10px' } }>
                        {selectComponent}
                    </div>
                </Flexbox>
            </div>
        );
    }

    render() {
        if (this.props.projectParameters) {
            return this.renderForm();
        }
        return <div/>;
    }
}

const mapStateToProps = (storeState, ownProps) => {
    const processId = ownProps.processId;
    const processState = ProcessService.getMyState(storeState);
    const process = processState.workingCopiesById[processId];
    const projectParameters = processState.projectParametersById[processId].parameters;

    return {
        process,
        projectParameters
    };
};

export default connect(mapStateToProps)(TemplateOptionsForm);



// WEBPACK FOOTER //
// ./src/components/core/forms/TemplateOptionsForm.js